export default "__VITE_ASSET__ba1a3af8__"